import { z } from 'zod';
const uuid = z.string().uuid();
const dateTime = z.string().datetime({ offset: true });
export const cardStateSchema = z.enum([
    'registered',
    'active',
    'blocked',
    'lost',
    'returned',
    'revoked',
    'replaced',
]);
export const cardSummarySchema = z.object({
    id: uuid,
    standard: z.string().min(1).max(80),
    displayIdentifier: z.string().min(1).max(32),
    state: cardStateSchema,
    assignmentVersion: z.number().int().nonnegative(),
    assignedPersonId: uuid.nullable(),
    assignedPersonName: z.string().min(1).max(200).nullable(),
    assignedAt: dateTime.nullable(),
    lastChangedAt: dateTime,
});
export const cardListSchema = z.object({
    items: z.array(cardSummarySchema),
    total: z.number().int().nonnegative(),
});
const readerOrManualMediumSchema = z
    .object({
    uid: z.string().trim().min(4).max(64).optional(),
    readerEvidenceId: uuid.optional(),
})
    .superRefine((value, context) => {
    if (Boolean(value.uid) === Boolean(value.readerEvidenceId))
        context.addIssue({
            code: 'custom',
            message: 'Podaj UID ręcznie albo dowód odczytu, ale nie oba naraz.',
        });
});
export const assignCardRequestSchema = readerOrManualMediumSchema.and(z.object({
    personId: uuid,
    reason: z.string().trim().min(3).max(500),
    idempotencyKey: uuid,
}));
export const cardActionSchema = z.enum([
    'detach',
    'activate',
    'block',
    'mark_lost',
    'return',
    'revoke',
    'restore',
]);
export const cardActionRequestSchema = z.object({
    action: cardActionSchema,
    reason: z.string().trim().min(3).max(500),
    idempotencyKey: uuid,
});
export const replaceCardRequestSchema = z
    .object({
    newUid: z.string().trim().min(4).max(64).optional(),
    readerEvidenceId: uuid.optional(),
    reason: z.string().trim().min(3).max(500),
    idempotencyKey: uuid,
})
    .superRefine((value, context) => {
    if (Boolean(value.newUid) === Boolean(value.readerEvidenceId))
        context.addIssue({
            code: 'custom',
            message: 'Podaj nowy UID ręcznie albo dowód odczytu, ale nie oba naraz.',
        });
});
export const cardPolicySchema = z.object({
    id: uuid,
    groupId: uuid.nullable(),
    groupName: z.string().min(1).max(200).nullable(),
    maxActiveCards: z.number().int().min(1).max(20),
    version: z.number().int().positive(),
    updatedAt: dateTime,
});
export const updateCardPolicySchema = z.object({
    groupId: uuid.nullable(),
    groupName: z.string().trim().min(1).max(200).nullable(),
    maxActiveCards: z.number().int().min(1).max(20),
    reason: z.string().trim().min(3).max(500),
});
export const cardHistoryEntrySchema = z.object({
    id: uuid,
    cardId: uuid,
    action: z.string().min(1).max(80),
    personId: uuid.nullable(),
    actorId: uuid,
    reason: z.string().min(1).max(500),
    occurredAt: dateTime,
});
